import {
  DELETE_CREW_REQUEST,
  DELETE_CREW_ERROR,
  DELETE_CREW_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/deleteEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default entity => (state = initialState, action) => {

  context.init(context);

  context.DELETE_ENTITY_REQUEST = DELETE_CREW_REQUEST;
  context.DELETE_ENTITY_ERROR = DELETE_CREW_ERROR;
  context.DELETE_ENTITY_SUCCESS = DELETE_CREW_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "crew";
  context.entityLocation = RESOURCES.Crews;

  return context.execute(context)(entity)(state, action);
};

